import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'Displays',
    breadcrumbName: 'Displays',
  },
];

const Displays = () => {
  return (
    <>
      <PageHeader title="Displays" breadcrumb={{ routes }} subTitle="Display-Values" style={{ padding: 10 }} />

      <div className="MF_area">
        <ul>
          <li>dp_{`{value}`}</li>
        </ul>
        <ul>
          <li>none</li>
          <li>inline</li>
          <li>inline_b : inline-block</li>
          <li>block</li>
          <li>table</li>
          <li>table_r : table-row</li>
          <li>table_c : table-cell</li>
        </ul>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="dp_none"></div>
<div class="dp_inline"></div>
<div class="dp_inline_b"></div>
<div class="dp_block"></div>
<div class="dp_table"></div>
<div class="dp_table_r"></div>
<div class="dp_table_c"></div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>
    </>
  );
}

export default Displays;
